export default {
  // CLUBS
  UPDATE_CLUB: 'update',

  // TEAM
  MANAGE_TEAM: 'manage-team',
  UPDATE_TEAM: 'update',
}
